import React from 'react';
import { Table } from 'semantic-ui-react';
import { map, addIndex } from 'ramda';
import i18next from 'i18next';
import TableHeader from './Header.js';
import TableRow from './Row.js';
import TableFooter from './Footer.js';
import { generate } from 'shortid';

const parseIfJson = (title) => {
  return typeof title === 'string' ? JSON.parse(title) : title;
};

const TransactionTable = (props) => {
  const { data = [] } = props,
        ixMap = addIndex(map);

  return (
    <Table>
      <TableHeader />
      <Table.Body>
        { ixMap((t, ix) =>
                <TableRow
                  key={generate()}
                  ix={ix + 1}
                  eventTitle={t.event.title}
                  competitionTitle={
                    parseIfJson(t.competition.i18n_title)[i18next.language] +
                      ' (' + t.competition.code + ')'
                  }
                  teamName={t.name}
                  robotName={t.robotName}
                  orig_price={t.orig_price}
                  discount={t.discount || 0}
                  sale_price={t.sale_price}
                  tax={t.tax}
                  total={t.total} />, data)}
      </Table.Body>
      <TableFooter data={data}/>
    </Table>
  );
};

export default TransactionTable;



// WEBPACK FOOTER //
// ./src/private/common/components/TransactionTable/index.js